/*
 * @Author: lixin jiang
 * @Date: 2021-07-12 09:21:47
 * @LastEditTime: 2021-07-15 14:31:55
 * @LastEditors: lixin jiang
 * @Description:
 * @FilePath: /aid-base/src/components/Tabs/index.js
 * @
 */

import Tabs from './tabs';

export default Tabs;

